import { render, staticRenderFns } from "./LaborProtectionAccidentsTable.vue?vue&type=template&id=5cd51222&"
import script from "./LaborProtectionAccidentsTable.vue?vue&type=script&lang=ts&"
export * from "./LaborProtectionAccidentsTable.vue?vue&type=script&lang=ts&"
import style0 from "./LaborProtectionAccidentsTable.vue?vue&type=style&index=0&id=5cd51222&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports